import styled from "styled-components";

export const HeroContainer = styled.section`
  background: var(--primary-400);
  color: var(--text-primary);
  overflow: hidden;
`;

export const HeroInner = styled.div`
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: clamp(3.5rem, 8vw, 6.5rem) var(--space-6) clamp(3rem, 6vw, 5rem);
  display: grid;
  grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
  gap: var(--space-10);
  align-items: center;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: var(--space-8);
  }
`;

export const HeroText = styled.div``;

export const HeroHeading = styled.h1`
  max-width: 14ch;
  font-size: clamp(2.5rem, 6vw, 4.75rem);
  font-weight: var(--font-weight-black);
  line-height: 1.1;
  letter-spacing: -0.04em;
  color: var(--text-primary);
  word-break: keep-all;
  text-wrap: balance;
`;

export const HeroSubtitle = styled.p`
  max-width: 32rem;
  margin-top: var(--space-6);
  font-size: 1.125rem;
  line-height: 1.7;
  font-weight: var(--font-weight-medium);
  color: var(--brand-dark);
  word-break: keep-all;
  text-wrap: pretty;

  @media screen and (max-width: 768px) {
    font-size: var(--font-size-base);
    margin-top: var(--space-5);
  }
`;

export const HeroLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  margin-top: var(--space-8);
`;

export const HeroMascot = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  & img {
    width: min(100%, 380px);
    height: auto;
    transform: rotate(-6deg);
    user-select: none;
  }

  @media screen and (max-width: 900px) {
    order: -1;
    justify-content: flex-start;

    & img {
      width: 160px;
      transform: rotate(-8deg);
    }
  }
`;
